export const ADMIN_SESSION_EXPIRED_EVENT = 'milkrunn:admin-session-expired'

type ApiErrorLike = {
  config?: {
    url?: string
  }
  response?: {
    status?: number
    data?: {
      message?: string
    }
  }
}

let adminSessionExpired = false
const LOGIN_PATHS = new Set(['/auth/login', '/sso/authAPI'])

export const isAdminSessionExpiredError = (error: unknown): boolean => {
  const candidate = error as ApiErrorLike
  const status = candidate.response?.status
  const message = candidate.response?.data?.message
  const requestUrl = candidate.config?.url || ''

  return (
    status === 401 &&
    message === 'Invalid or expired Admin session' &&
    !LOGIN_PATHS.has(requestUrl)
  )
}

export const hasAdminSessionExpired = (): boolean => adminSessionExpired

export const notifyAdminSessionExpired = (): void => {
  if (adminSessionExpired) return
  adminSessionExpired = true

  if (typeof window !== 'undefined') {
    window.dispatchEvent(new CustomEvent(ADMIN_SESSION_EXPIRED_EVENT))
  }
}
